export default "__VITE_ASSET__BZw41v6G__"